import { assert } from '@fe/core';
import { TextRenderer, TextSpriteData } from '../text/text-renderer';

export type TemperatureRenderingProperties = {
    font?: string | null;
    color?: string | null;
    minTemperature?: number;
    maxTemperature?: number;
};

const width = 32;
const height = 32;
const MIN_TEMPERATURE = -90;
const MAX_TEMPERATURE = 50;

export class TemperatureTextRenderer implements TextRenderer<Int8Array> {
    private canvas: OffscreenCanvas | null = null;
    private _color: string;
    private font: string;
    private minTemperature: number;
    private maxTemperature: number;
    private itemsCount: number;

    constructor(properties?: TemperatureRenderingProperties) {
        this._color = properties?.color ?? '#000';
        this.font = properties?.font ?? '12px Arial';
        this.minTemperature = properties?.minTemperature ?? MIN_TEMPERATURE;
        this.maxTemperature = properties?.maxTemperature ?? MAX_TEMPERATURE;
        assert(this.minTemperature < this.maxTemperature, 'minTemperature must be less than maxTemperature');
        this.itemsCount = this.maxTemperature - this.minTemperature + 1;
    }

    private render(): void {
        this.canvas ??= new OffscreenCanvas(width, height * this.itemsCount);
        const ctx = this.canvas.getContext('2d')!;
        ctx.beginPath();
        ctx.clearRect(0, 0, width, height * this.itemsCount);
        ctx.font = this.font;
        ctx.fillStyle = '#000';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        for (let i = 0; i < this.itemsCount; i++) {
            const temperature = i + this.minTemperature;
            const y = height * i + height / 2;
            const x = width / 2;

            ctx.fillText(`${temperature}`, x, y);
        }
        ctx.closePath();
    }

    public getSpriteData(data: Int8Array): TextSpriteData | null {
        if (!this.canvas) {
            this.render();
        }

        return {
            data: this.canvas!,
            width,
            height,
            isSdf: false,
            offsets: new Uint8Array(data.map((temperature) => temperature - this.minTemperature)),
            length: this.itemsCount
        };
    }
}
